import { isOfType } from "@bitwarden/web-vault/app/models/types/general-types";

export type UserLocationType = "AU" | "HK" | "NZ" | "US" | "EU" | "JP" | "CN";
export type CurrencyType =
  | "USD"
  | "EUR"
  | "JPY"
  | "GBP"
  | "CNY"
  | "AUD"
  | "CAD"
  | "CHF"
  | "HKD"
  | "SGD"
  | "SEK"
  | "KRW"
  | "NOK"
  | "NZD"
  | "INR"
  | "MXN"
  | "TWD"
  | "ZAR"
  | "TRY"
  | "PHP"
  | "AFN"
  | "IRR"
  | "LKR"
  | "MMK"
  | "NPR"
  | "PKR"
  | "SYP"
  | "VND";

/** This control the full list in the system, or default to DefaultSystemCurrency if not found ( need to match with what the scope and claim forex return **/
export const AllowedCurrencies: CurrencyType[] = [
  "USD",
  "EUR",
  "JPY",
  "GBP",
  "CNY",
  "AUD",
  "CAD",
  "CHF",
  "HKD",
  "SGD",
  "SEK",
  "KRW",
  "NOK",
  "NZD",
  "INR",
  "MXN",
  "TWD",
  "ZAR",
  "TRY",
  "PHP",
  "AFN",
  "IRR",
  "LKR",
  "MMK",
  "NPR",
  "PKR",
  "SYP",
  "VND",
] as const;

/** This control the current list of available location to chose from. This should be a subset of UserLocationType **/
export const AllowedLocations: UserLocationType[] = ["AU", "HK", "US"] as const;

/** System default **/
export const DefaultSystemCurrency: CurrencyType = "AUD" as const;
export const DefaultSystemLocation: UserLocationType = "AU" as const;

export const DefaultCurrencyPerLocation: Record<UserLocationType, CurrencyType> = {
  AU: "AUD",
  HK: "HKD",
  NZ: "NZD",
  US: "USD",
  EU: "EUR",
  JP: "JPY",
  CN: "CNY",
} as const;

export const DefaultLocationPerCurrency: Record<CurrencyType, UserLocationType> = {
  ...Object.entries(DefaultCurrencyPerLocation).reduce(
    (acc, pair) => {
      acc[pair[1]] = pair[0] as UserLocationType;
      return acc;
    },
    {} as Record<CurrencyType, UserLocationType>,
  ),
};

export function getLocationCurrencyFromCountryCode(countryCode: string) {
  let locationCurrency = DefaultSystemCurrency;
  if (isOfType<UserLocationType>(countryCode, AllowedLocations)) {
    locationCurrency = DefaultCurrencyPerLocation[countryCode];
  }
  return locationCurrency;
}
